export const dimensionList = [
  { label: "媒体渠道", value: 1 },
  { label: "广告组", value: 2 },
  { label: "广告计划", value: 3 },
];

export function transFilterData(parmas) {
  let filterData = {
    dateStart: parmas.time[0],
    dateEnd: parmas.time[1],
  };
  for (let [key, value] of Object.entries(parmas)) {
    if (value !== null && value !== -1 && key !== "time") {
      filterData[key] = value;
    }
  }
  return filterData;
}
